import Vue from 'vue'
import Febs from './FEBS'
import router from './router'
import Antd from 'ant-design-vue'
import store from './store'
import request from 'utils/request'
import { API_BASE } from 'utils/apiConfig'
import db from 'utils/localstorage'
import AesEncrypt from 'utils/aesEncrypt'
import VueMeta from 'vue-meta'
import 'ant-design-vue/dist/antd.css'
import echarts from 'echarts'
import 'utils/install'
import $ from 'jquery'
// import '../static/fonts/iconfont.css'
import VueI18n from 'vue-i18n'
import zhCN from './lang/zh-CN'
import enUS from './lang/en-US'
import thTH from './lang/th-TH'
import viVN from './lang/vi-VN'
import msMY from './lang/ms-MY'
import idID from './lang/id-ID'
import deDE from './lang/de-DE'
import esES from './lang/es-ES'
import frFR from './lang/fr-FR'

Vue.use(VueI18n)

function getBrowserLang() {
  const lang = navigator.language || navigator.userLanguage
  if (lang.toLowerCase().includes('zh')) return 'zh-CN'
    else return 'en-US'
}
// 未手动选择语言时，默认跟随浏览器语言（中文→zh-CN，其余→en-US）
const savedLang = localStorage.getItem('lang') || getBrowserLang()
const i18n = new VueI18n({
  locale: savedLang,
  // 其他语言缺少新增文案（如 forgotPwd）时回退到英文，避免直接显示 key 路径
  fallbackLocale: 'en-US',
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS,
    'th-TH': thTH,
    'vi-VN': viVN,
    'ms-MY': msMY,
    'id-ID': idID,
    'de-DE': deDE,
    'es-ES': esES,
    'fr-FR': frFR
  }
})

Vue.config.productionTip = false
Vue.use(Antd)
Vue.use(db)
Vue.use(VueMeta)
Vue.prototype.$echarts = echarts
Vue.use({
  install (Vue) {
    Vue.prototype.$db = db
  }
})

Vue.prototype.$post = request.post
Vue.prototype.$get = request.get
Vue.prototype.$put = request.put
Vue.prototype.$delete = request.delete
Vue.prototype.$export = request.export
Vue.prototype.$download = request.download
Vue.prototype.$upload = request.upload
Vue.prototype.$originalGet = request.originalGet
Vue.prototype.$downloadGet = request.downloadGet
Vue.prototype.$aesEncrypt = AesEncrypt

/* eslint-disable no-new */
new Vue({
  i18n,
  router,
  store,
  render: h => h(Febs),
  mounted() {
    // 设置初始标题
    document.title = this.$t('company.name')
    // 监听语言切换，动态修改标题
    this.$watch(() => this.$i18n.locale, () => {
      document.title = this.$t('company.name')
    })
  }
}).$mount('#febs')
//文件上传相关配置：统一从 apiConfig 派生（已协议自适应），与 request.js 的 baseURL 保持一致
//切换环境只需修改 config/prod.env.js(或 dev/test.env.js) 中的 BACKEND_API_HOST，无需再改此处
window.http = API_BASE



// WEBPACK FOOTER //
// ./src/main.js